<template lang="html">
  <div class="">
    <v-container
      grid-list-xl
      fluid
      px-6
    >
      <v-layout wrap>
        <v-flex
          xs12
          sm6
          md6
          xl3
        >
          <SiStatCard
            :value="totals.purchased"
            label="Purchased FLV (YTD)"
            icon="shopping_cart"
            color="success"
            :format="v => !isNaN(v) ? Number(v).toFixed(0) : 0"
            :month-bar="subTotals.purchased"
          />
        </v-flex>
        <v-flex
          xs12
          sm6
          md6
          xl3
        >
          <SiStatCard
            :value="totals.revenue"
            label="Revenue (YTD)"
            icon="attach_money"
            color="cyan"
            :format="v => !isNaN(v) ? _$(v, 0) : 0"
            :month-bar="subTotals.revenue"
          />
        </v-flex>
        <v-flex
          xs12
          sm6
          md6
          xl3
        >
          <SiStatCard
            :value="totals.visitors"
            label="Unique Visitors (MTD)"
            icon="language"
            color="pink"
            :format="v => !isNaN(v) ? Number(v).toFixed(0) : 0"
            :month-bar="subTotals.visitors"
          />
        </v-flex>
        <v-flex
          xs12
          sm6
          md6
          xl3
        >
          <SiStatCard
            :value="totals.rating"
            label="Rating"
            icon="star"
            color="yellow darken-2"
            :format="v => !isNaN(v) ? Number(v).toFixed(2) : 0"
            :sub-label="`Ratings: <strong>${subTotals.rating}</strong>`"
          />
        </v-flex>
      </v-layout>

      <v-layout wrap>
        <v-flex
          xs12
          md7
        >
          <v-layout
            ma-0
            py-3
            align-center
            class="headline font-weight-light"
          >
            <v-icon left>
              assessment
            </v-icon>Calculator Usage
          </v-layout>
          <v-card>
            <v-layout
              wrap
              ma-0
              pa-4
              align-center
            >
              <v-layout
                ma-0
                align-center
              >
                <v-switch
                  v-model="usageShowRuns"
                  hide-details
                  :color="graphColors[0][0]"
                  class="ml-4 ma-0 pa-0"
                />
                <span class="caption grey--text text--darken-2">{{ usageShowRuns ? 'All' : 'Purchases' }}</span>
              </v-layout>
              <v-spacer />
              <SiMonthRangePicker
                v-model="usageRange"
                color="grey darken-2"
              />
            </v-layout>
            <v-card-text class="pa-3">
              <SiChartLine
                :labels="usageLabels"
                :series="usageDatasets"
              />
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex
          xs12
          md5
        >
          <v-layout
            ma-0
            py-3
            align-center
            class="headline font-weight-light"
          >
            <v-icon left>
              attach_money
            </v-icon>Revenue {{ _$(revenueTotal, 0) }}
          </v-layout>
          <v-card>
            <v-layout
              wrap
              ma-0
              pa-4
              align-center
              class="headline pa-3 white--text"
            >
              <v-spacer />
              <SiMonthRangePicker
                v-model="revenueRange"
                month-only
                default-size="13                   "
                color="grey darken-2"
              />
            </v-layout>
            <v-card-text class="pa-3">
              <SiChartBar
                :labels="revenueLabels"
                :series="revenueDatasets"
                :label-format="v => v > 0 ? _$(v, 0) : ''"
                trendline
              />
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout wrap>
        <v-flex
          xs12
          md6
        >
          <v-layout
            ma-0
            py-3
            align-center
            class="headline font-weight-light"
          >
            <v-icon
              left
              color=""
            >
              face
            </v-icon>Top Clients
            <v-spacer />
          </v-layout>
          <v-card>
            <v-card-text class="pa-3">
              <v-data-table
                :headers="topClientHeaders"
                :items="_sortObject((stats || {}).clients, '_total')"
                :items-per-page="5"
                sort-by="_revenue"
                sort-desc
                @click:row="$router.push(`/clientpath/identity/${$event.id}?back=${$route.path}`)"
              >
                <template #item.id="{ item }">
                  <div class="cursor-pointer">
                    {{ atob(item.id) }}
                  </div>
                </template>
                <template #item._revenue="{ item }">
                  <v-flex
                    v-if="item._revenue"
                    pa-0
                    text-right
                  >
                    {{ _$(item._revenue) }}
                  </v-flex>
                </template>
                <!-- <template v-slot:item._assistance="{ item }">
                  <v-icon left :color="item._assistance ? 'grey' :'grey lighten-3'">face</v-icon> {{item._assistance}}
              </template> -->
                <template #item._total="{ item }">
                  <v-tooltip
                    left
                    :disabled="!item._total"
                  >
                    <template #activator="{ on }">
                      <div
                        class="cursor-pointer"
                        v-on="on"
                      >
                        <v-icon
                          left
                          :color="item._total ? 'grey' :'grey lighten-3'"
                        >
                          assessment
                        </v-icon>{{ item._total }}
                      </div>
                    </template>
                    <v-layout
                      v-for="c in filterCalculations(item)"
                      :key="c.id"
                    >
                      <v-flex mr-2>
                        {{ calculatorVairantName(c.id) }}:
                      </v-flex>
                      <v-flex class="font-weight-bold text-right">
                        {{ c.count }}
                      </v-flex>
                    </v-layout>
                    <template v-if="item._assistance">
                      <v-divider
                        color="white"
                        class="my-2"
                      />
                      <v-layout>
                        <v-flex mr-2>
                          Assistance:
                        </v-flex>
                        <v-flex class="font-weight-bold text-right">
                          {{ item._assistance }}
                        </v-flex>
                      </v-layout>
                    </template>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex
          xs12
          md6
        >
          <v-layout
            ma-0
            py-3
            align-center
            class="headline font-weight-light"
          >
            <v-icon
              left
              color=""
            >
              link
            </v-icon>Top Referrers
          </v-layout>
          <v-card>
            <v-card-text class="pa-3">
              <v-data-table
                :headers="topReferrersHeaders"
                :items="referrers"
                :items-per-page="5"
                sort-by="count"
                sort-desc
              >
                <template #item.host="{ item }">
                  <span class="text-no-wrap">{{ item.host }}</span>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout wrap>
        <v-flex xs12>
          <v-layout
            ma-0
            py-3
            align-center
            class="headline font-weight-light"
          >
            <v-icon
              left
              color=""
            >
              account_balance
            </v-icon>Super Types
          </v-layout>
          <v-layout wrap>
            <template v-for="(dataset, i) in superTypeDatasets">
              <v-flex
                :key="i"
                xs12
                sm6
                lg4
                xl3
              >
                <v-card>
                  <v-card-title class="title">
                    {{ dataset.name }}
                  </v-card-title>
                  <v-card-text class="pa-3">
                    <SiChartPie
                      :labels="superTypeLabels[i]"
                      :series="dataset.data"
                    />
                  </v-card-text>
                </v-card>
              </v-flex>
            </template>
          </v-layout>
        </v-flex>
      </v-layout>


      <v-layout wrap>
        <v-flex xs12>
          <v-layout
            ma-0
            py-3
            align-center
            class="headline font-weight-light"
          >
            <v-icon
              left
              color=""
            >
              face
            </v-icon>Client types
          </v-layout>
          <v-layout wrap>
            <v-flex
              xs12
              sm6
              lg4
              xl3
            >
              <v-card>
                <v-card-text class="pa-3">
                  <SiChartPie
                    :labels="clientTypeLabels"
                    :series="clientTypeDataset"
                  />
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { forEach } from 'lodash'
import helpers from '@/mixins/helpers'
import binder from '@/mixins/binder'
import analytics from '@/mixins/analytics'
import moment from 'moment'
import createTrend from 'trendline';

export default {
  mixins: [ helpers, binder, analytics ],
  data () {
    return {
      stats: { clients: {} },
      period: 'day',
      length: 26,
      revenueRange: {},
      revenueLabels: [],
      revenueDatasets: [],
      revenueTotal: 0,
      usageRange: {},
      usageShowRuns: false,
      usageLabels: [],
      usageDatasets: [],
      superTypeLabels: [],
      superTypeDatasets: [],
      clientTypeLabels: [],
      clientTypeDataset: [],
      fingerprintIdentityMap: {},
      topClientHeaders: [
        { text: 'Client', value: 'id' },
        { text: 'Revenue', value: '_revenue', width: 100 },
        { text: 'Calculations', value: '_total', width: 50 },
        // { text: 'Assit', value: '_assistance', width: 50 },
      ],
      topReferrersHeaders: [
        { text: 'Count', value: 'count', width: 50},
        { text: 'Host', value: 'host' },
        { text: 'Referrer', value: 'id' }
      ],
      totals: {},
      subTotals: { purchased: {}, revenue: {}, rating: 0, visitors: {} }
    }
  },
  computed: {
    ...mapGetters(['_calculators']),
    graphColors () {
      return ['#3266CC','#DE3713','#FF9D04','#109717','#9B0195','#009CC3','#D74874','#66A900','#C02C24','#316199','#994499']
      // return [
      //   ['#03A9F4', '#039BE5', '#0288D1', '#0277BD', '#01579B'],
      //   ['#2196F3', '#1E88E5', '#1976D2', '#1565C0', '#0D47A1'],
      //   ['#00BCD4', '#00ACC1', '#0097A7', '#00838F', '#006064'],
      //   ['#3F51B5', '#3949AB', '#303F9F', '#283593', '#1A237E']
      // ]
    },
    revenueOptions () {
      return {
        scales: {
          yAxes: [{
            display: true,
            ticks: {
              beginAtZero: true,
              userCallback: v => this._$(v, 0)
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, chart) => {
              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || ''
              return `${datasetLabel}: ${this._$(tooltipItem.yLabel)}`
            }
          }
        }
      }
    },
    referrers () {
      let refs = (this.stats || {}).referrers || {}
      return Object.keys(refs).map(k => { return { id: atob(k), host: this._hostFromUrl(atob(k)), count: refs[k] } })
    }
  },
  watch: {
    stats: {
      handler () {
        this.setTotals()
        this.setClientTypeData()
      },
      deep: true
    },
    'stats.revenue': {
      handler () {
        this.setRevenueData()
      },
      deep: true
    },
    'stats.calculations': {
      handler () {
        this.setUsageData()
        this.setSuperTypeData()
      },
      deep: true
    },
    usageShowRuns () {
      this.setUsageData()
    },
    usageRange () {
      this.setUsageData()
    },
    revenueRange () {
      this.setRevenueData()
    }
  },
  beforeMount () {
    this.$bindRtdb('stats', 'stats', { loader: true })
    this.$bindRtdb('fingerprintIdentityMap', 'clientPath/_indexFingerprintIdentityMap')
    // this.$bindxxx(rtdb.ref('stats/'), 'stats', true)
    // this.$bindxxx(rtdb.ref('clientPath/_indexFingerprintIdentityMap'), 'fingerprintIdentityMap')
    this.$store.commit('set_appBarTitle', 'Dashboard')
  },
  methods: {
    atob (str) {
      try {
        return str ? atob(str) : ''
      } catch (e) {
        return ''
      }
    },
    calculatorVairantName (statId = '') {
      let [calculatorId, variantId] = statId.split('_') || []
      let variants = (this._calculators[calculatorId] || {}).variants || {}
      return (variants[variantId] || {}).name || ''
    },
    setSuperTypeData () {
      let calculations = this.stats.calculations || {}

      this.superTypeDatasets = []
      this.superTypeLabels = []
      // this.superTypeLabels = ['css', 'dfrdb', 'msbs', 'pss', 'pssap']

      forEach(calculations, (calculatorStats, calculatorId) => {
        let data = []
        let labels = []

        // forEach(this.superTypeLabels, id => { data.push(superType[id] || 0) })
        forEach(calculatorStats.superType, (count, type) => {
          data.push(count || 0)
          labels.push(type.toUpperCase())
        })

        this.superTypeDatasets.push({
          name: `${calculatorId.toUpperCase()}`,
          data: data
        })
        this.superTypeLabels.push(labels)
      })
    },
    setClientTypeData () {
      this.clientTypeDataset = []
      this.clientTypeLabels = []

      let clientType = this.stats.clientType || {}

      forEach(clientType, (count, id) => {
        this.clientTypeLabels.push(this._capitalize(id))
        this.clientTypeDataset.push(count)
      })
    },
    setUsageData () {
      this.usageLabels = []
      this.usageDatasets = []
      let calculations = this.stats.calculations || {}
      let end = this.usageRange.end
      let start = this.usageRange.start
      let length = moment(end).diff(start, 'days')
      let step = length >= 185 ? 'month' : length >= 32 ? 'week' : 'day'

      this.usageLabels = this._chartLabels(start, end, step)

      forEach(calculations, (calculatorStats, calculatorId) => {
        let dataset
        var usage = calculatorStats.usage || {}
        var purchases = calculatorStats.purchases || {}

        dataset = {
          name: `${calculatorId.toUpperCase()} - Runs`,
          data: this._dataToChartData(usage, start, end, step)
        }
        if (this.usageShowRuns) this.usageDatasets.push(dataset)
        dataset = {
          name: `${calculatorId.toUpperCase()}  - Purchases`,
          // data: Object.keys(purchases).map(k => purchases[k])
          data: this._dataToChartData(purchases, start, end, step)
        }
        this.usageDatasets.push(dataset)
      })
    },
    setRevenueData () {
      this.revenueLabels = []
      this.revenueDatasets = []
      let revenue = this.stats.revenue || {}
      let start = this.revenueRange.start
      let end = this.revenueRange.end
      let length = moment(end).diff(start, 'days')
      let step = length >= 63 ? 'month' : 'week'
      let chartData = this._dataToChartData(revenue, start, end, step)
      
      this.revenueLabels = this._chartLabels(start, end, step)
      this.revenueTotal = chartData.reduce((t, cv) => t += cv)

      let xyData = chartData.reduce((arr, y, x) => ([...arr, { y, x }]),[])

      const trend = createTrend(xyData, 'x', 'y');
      let dataset = {
        name: `Revenue`,
        type: 'column',
        data: chartData
      }
      let trendLineDataset = {
        name: `Trend`,
        type: 'line',
        data: chartData.map((d, i) => trend.calcY(i))
      }

      this.revenueDatasets = [dataset, trendLineDataset]
    },
    setTotals () {
      let year = moment().year()
      let month = moment().month()
      let fyStart = Number(moment(`${year - (month < 6 ? 1 : 0)}-07-01`).format('YYYYMMDD'))
      let fyEnd = Number(moment(`${year + (month < 6 ? 0 : 1)}-06-30`).format('YYYYMMDD'))

      let revenue = this.stats.revenue || {}
      let visitors = this.stats.visitors || {}
      let ratings = (this.stats.ratings || {}).calculator || {}
      let calculations = this.stats.calculations || {}

      let totalRevenue = this._sumData(revenue, fyStart, fyEnd)
      this.$set(this.totals, 'revenue', totalRevenue)
      this.$set(this.subTotals, 'revenue', this._monthComparison(revenue))

      let i = 0
      let total = 0
      let cnt = 0
      forEach(ratings, calcRating => {
        let rating = calcRating.overall
        total += this._calculateRating(rating)
        cnt = Object.keys(rating).map(k => rating[k]).reduce((t, cv) => t = Number(t) + Number(cv), 0)
        i++
      })

      this.$set(this.totals, 'rating', total / i)
      this.$set(this.subTotals, 'rating', cnt)

      let totalCalcs = 0
      let subTotal
      forEach(calculations, (calcStats, calcId) => {
        // TODO: remove if later as only using to focus on FLV target
        if (calcId === 'flv') {
          let purchases = calcStats.purchases || {}
          let calcTotal = this._sumData(purchases, fyStart, fyEnd)
          subTotal = this._monthComparison(purchases, subTotal)
          totalCalcs += calcTotal
        }
      })
      this.$set(this.totals, 'purchased', totalCalcs)
      this.$set(this.subTotals, 'purchased', subTotal)

      let visitorData = this._analyseVisits(visitors, this.fingerprintIdentityMap)
      this.$set(this.totals, 'visitors', visitorData.mtd)
      this.$set(this.subTotals, 'visitors', visitorData)
    },
    filterCalculations(calculations) {
      let filterCalculations = []
      forEach(calculations, (count, id) => {
        if (id.substr(0,1) !== '_' && id !== 'id') filterCalculations.push({ id, count })
      })
      return filterCalculations
    }
  }
}

</script>

<style lang="css" scoped>

</style>
